module.exports = __webpack_public_path__ + "img/da1c514.png";